import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import Home from './pages/Home';
import ServicesPage from './pages/ServicesPage';
import PackagesPage from './pages/PackagesPage';
import GalleryPage from './pages/GalleryPage';
import ReviewsPage from './pages/ReviewsPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import './styles/globals.css';

function App() {
  // State to manage language across the entire application
  const [lang, setLang] = useState('en');

  // Toggle function passed to the Header/Navbar
  const toggleLang = () => {
    setLang((prev) => (prev === 'en' ? 'ar' : 'en'));
  };

  // Effect to update the HTML lang attribute for SEO and accessibility
  useEffect(() => {
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr';
  }, [lang]);

  return (
    <Router>
      {/* The 'dir' attribute here handles the layout flip (RTL/LTR) 
        The dynamic class ensures Arabic typography looks premium.
      */}
      <div
        className={`min-h-screen flex flex-col transition-colors duration-300 ${
          lang === 'ar' ? 'font-arabic' : 'font-sans'
        }`}
        dir={lang === 'ar' ? 'rtl' : 'ltr'}
      >
        {/* Pass lang and toggleLang to Header for the switch button */}
        <Header lang={lang} toggleLang={toggleLang} />

        <main className='flex-grow overflow-x-hidden'>
          <Routes>
            <Route path='/' element={<Home lang={lang} />} />
            <Route path='/services' element={<ServicesPage lang={lang} />} />
            <Route path='/packages' element={<PackagesPage lang={lang} />} />
            <Route path='/gallery' element={<GalleryPage lang={lang} />} />
            <Route path='/reviews' element={<ReviewsPage lang={lang} />} />
            <Route path='/about' element={<AboutPage lang={lang} />} />
            <Route path='/contact' element={<ContactPage lang={lang} />} />

            {/* Fallback for 404s */}
            <Route path='*' element={<Home lang={lang} />} />
          </Routes>
        </main>

        <Footer lang={lang} />

        {/* Floating Button that stays updated with the language */}
        <WhatsAppButton lang={lang} />
      </div>
    </Router>
  );
}

export default App;
